import React from "react";
import Icon from "./Icon";
import type { IconProps } from "./IconProps";

const CheckIcon: React.FC<IconProps> = ({ className, title }) => {
  const svgPath = (
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  );

  return (
    <Icon
      svgPath={svgPath}
      className={className}
      title={title}
      fill="none"
      strokeWidth={1.5}
    />
  );
};

export default CheckIcon;
